module.exports = __webpack_public_path__ + "src/assets/animations/tree.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animations/tree.png
// module id = ./src/assets/animations/tree.png
// module chunks = 0